<template>
  <section>
    <div v-if="data.label !== null">
    <highcharts ref="trend" class="hc" :options="options"></highcharts>
    </div>
    <div
      v-else
      class="loader  py-3 px-md-2 px-1"
      style="height:420px"
    >
     <EmptyData/>
    </div>
  </section>
</template>
<script>
import { Chart } from 'highcharts-vue'
import EmptyData from '@/components/utilities/elements/emptyData.vue'
export default {
  name: 'SplineChart',
  components: {
    EmptyData,
    highcharts: Chart
  },
  props: {
    chartOptions: Object,
    chartYaxis: Object,
    data: Object
  },
  computed: {
    options() {
      let _options = {
        chart: {
          type: 'areaspline'
        },
        credits: {
          enabled: false
        },
        title: {
          text: this.data.label
        },
        xAxis: {
          categories: this.data.categories,
          labels: {
            enabled: false
          }
        },
        yAxis: [
          {
            labels: {
              format: '{value}'
            },
            title: {
              text: null
            }
          }
        ],
        series: this.data.splineData
      }
      return _options
    }
  }
}
</script>
<style lang="scss" scoped></style>
